export default angular.module('toggle', [])
    /**
     * @ngdoc controller
     * @name toggle.controller:toggle
     * @description
     * Scope for a single toggle group
     */
    // @ngInject
    .controller('toggle', function ($scope) {
        $scope.isActive = false;
        $scope.toggle = function (override) {
            return ($scope.isActive = typeof override === 'boolean' ?
                    override : !$scope.isActive);
        };
    })
    /**
     * @ngdoc directive
     * @name toggle.directive:toggle
     * @restrict A
     * @description
     * Assigns a new scope and controller for each group instance
     */
    // @ngInject
    .directive('toggleGroup', function ($document, AnalyticsService) {
        return {
            scope: true,
            controller: 'toggle',
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                var toggle_title = $element.find('h1').text() || ($element.children().length && angular.element($element.children()[0]).text());
                var is_dirty = false;
                var active_class = attrs.toggleClass || 'toggle--active';
                if (attrs.toggleGroup) {
                    if ('toggleOnHash' in attrs && location.hash.slice(1) === attrs.toggleOnHash) {
                        $scope.toggle(true);
                        if ('toggleScrollOffset' in attrs) {
                            var offset = parseInt(attrs.toggleScrollOffset, 10) || 0;
                            angular.element(document).ready(function () {
                                setTimeout(function () {
                                    $document.scrollToElement($element, offset);
                                }, 1);
                            });
                        }
                    }
                }
                if ($element.hasClass(active_class)) {
                    $scope.toggle(true);
                }
                $scope.$watch('isActive', function (is_active) {
                    $element.toggleClass(active_class, is_active);
                    if (toggle_title && is_dirty) {
                        AnalyticsService.trackEvent('Toggle', is_active ? 'Open' : 'Closed', toggle_title);
                    }
                    is_dirty = true;
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name toggle.directive:activeToggle
     * @restrict A
     * @description
     * Sets the group state to active on initialization
     */
    // @ngInject
    .directive('activeToggle', function () {
        return {
            restrict: 'A',
            link: function ($scope) {
                $scope.toggle(true);
            }
        };
    })
    /**
     * @ngdoc directive
     * @name toggle.directive:toggle
     * @restrict A
     * @description
     * Toggle the current state of the group
     */
    // @ngInject
    .directive('toggle', function ($document) {
        return {
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                var active_class = attrs.toggleClass || 'toggle--active';
                $element.on('click', function (e) {
                    e.preventDefault();
                    $scope.$apply(function () {
                        $scope.toggle();
                        if ('toggleScroll' in attrs && $scope.isActive) {
                            var offset = parseInt(attrs.toggleScrollOffset, 10) || 0;
                            $document.scrollToElement($element, offset);
                        }
                    });
                });
                $scope.$watch('isActive', function (is_active) {
                    $element.toggleClass(active_class, is_active);
                    if ('toggleModal' in attrs) {
                        angular.element(document.body)
                            .toggleClass('toggle--modal', is_active);
                    }
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name toggle.directive:toggleInput
     * @restrict A
     * @description
     * Toggle the current state of the group when focusing/bluring on input
     */
    // @ngInject
    .directive('toggleInput', function () {
        return {
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                var active_class = attrs.toggleClass || 'toggle--active';
                $element.on('focus', function (e) {
                    e.preventDefault();
                    $scope.$apply(function () {
                        $scope.toggle(true);
                    });
                });
                $element.on('blur', function (e) {
                    e.preventDefault();
                    $scope.$apply(function () {
                        $scope.toggle(false);
                    });
                });
                $scope.$watch('isActive', function (is_active) {
                    $element.toggleClass(active_class, is_active);
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name toggle.directive:toggleBroadcast
     * @restrict A
     * @description
     * Allows broadcasting and watching for toggle events outside of
     * the provided scope.
     */
    // @ngInject
    .directive('toggleBroadcast', function ($rootScope) {
        return {
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                var id = attrs.toggleBroadcast;
                $scope.$watch('isActive', function (is_active) {
                    $rootScope.$broadcast('toggle', {
                        id: id,
                        action: 'has_changed',
                        is_active: is_active
                    });
                });
                $scope.$on('toggle', function (event, args) {
                    if (args.id === id && args.action === 'to_change') {
                        $scope.$apply(function () {
                            $scope.toggle();
                        });
                    }
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name toggle.directive:globalToggle
     * @restrict A
     * @description
     * Toggle the current state of a broadcast enabled toggleGroup
     */
    // @ngInject
    .directive('globalToggle', function ($rootScope) {
        return {
            scope: true,
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                var active_class = attrs.toggleClass || 'toggle--active';
                var id = attrs.globalToggle;
                $scope.$on('toggle', function (event, args) {
                    if (args.id === id && args.action === 'has_changed') {
                        $element.toggleClass(active_class, args.is_active);
                    }
                });
                $element.on('click', function (e) {
                    e.preventDefault();
                    $rootScope.$broadcast('toggle', {
                        id: id,
                        action: 'to_change'
                    });
                });
            }
        };
    });
